import type { CSSProperties } from "react";
import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

/*
 * Avatar do bot e recuo esquerdo dos botões derivam dos MESMOS valores, para que a borda
 * esquerda dos botões fique alinhada com a do balão (mude o avatar e ambos acompanham).
 */
const AVATAR_SIZE_PX = 32;
const AVATAR_GAP_PX = 8; // mantenha igual ao marginRight do avatar (space30)
export const BUBBLE_LEFT_INSET_PX = AVATAR_SIZE_PX + AVATAR_GAP_PX; // recuo do balão = avatar + gap

export const outerContainerStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "column",
    marginBottom: "space40"
};

export const bubbleAndAvatarContainerStyles: BoxStyleProps = {
    display: "flex",
    alignItems: "flex-end"
};

export const getAvatarContainerStyles = (placeholder: boolean): BoxStyleProps => ({
    width: `${AVATAR_SIZE_PX}px`,
    height: `${AVATAR_SIZE_PX}px`,
    marginRight: "space30", // 8px (= AVATAR_GAP_PX)
    borderRadius: "borderRadiusCircle", // redondo (50%)
    overflow: "hidden",
    flex: "0 0 auto",
    display: "flex", // centraliza o ícone de fallback (e a foto) no meio da bolinha
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: placeholder ? "transparent" : "colorBackground"
});

export const getInnerContainerStyles = (belongToCurrentUser: boolean): BoxStyleProps => ({
    paddingTop: "space30",
    paddingBottom: "space30",
    paddingLeft: "space40",
    paddingRight: "space40",
    backgroundColor: belongToCurrentUser ? "colorBackgroundPrimaryStronger" : "colorBackground",
    color: belongToCurrentUser ? "colorTextWeakest" : "colorText",
    borderRadius: "borderRadius30",
    marginLeft: belongToCurrentUser ? "auto" : "space0",
    marginRight: belongToCurrentUser ? "space0" : "auto",
    maxWidth: "90%"
});

export const authorStyles: TextStyleProps = {
    color: "inherit",
    fontWeight: "fontWeightBold",
    fontSize: "fontSize20",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis", // doesn't get applied for some reason – need to investigate
    overflow: "hidden"
};

export const timeStampStyles: TextStyleProps = {
    fontSize: "fontSize20",
    marginLeft: "space40",
    color: "inherit"
};

export const bodyStyles: TextStyleProps = {
    color: "inherit",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word"
};

export const readStatusStyles: TextStyleProps = {
    textAlign: "right",
    fontSize: "fontSize10",
    marginRight: "space20",
    color: "colorText"
};

/*
 * Botões de resposta rápida (quick replies) — linha com quebra, à ESQUERDA (Zendesk usa à direita).
 * Os pequenos emparelham; os longos quebram pra própria linha. Largura ~ da bolha.
 */
export const messageButtonsContainerStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    marginTop: "space30",
    maxWidth: "90%"
    // marginLeft é aplicado inline (BUBBLE_LEFT_INSET_PX) p/ alinhar com a borda do balão
};

/*
 * Layout/hover do botão. O visual EXATO do Zendesk (14px, padding 8/16, borda preta,
 * raio 20px, cor #000, fundo transparente) vai inline no componente, em px medidos.
 */
export const messageButtonStyles: BoxStyleProps = {
    display: "inline-flex",
    alignItems: "center",
    /*
     * Texto longo quebra em várias linhas (cresce p/ baixo) e nunca passa da largura do balão —
     * senão um label grande estoura na horizontal e o chat rola pros lados.
     */
    whiteSpace: "normal",
    maxWidth: "100%",
    wordBreak: "break-word",
    textAlign: "left",
    backgroundColor: "transparent", // token (deixa o _hover sobrescrever)
    cursor: "pointer",
    transition: "background-color 0.15s",
    _hover: {
        backgroundColor: "colorBackground"
    },
    _focusVisible: {
        boxShadow: "shadowFocus",
        outline: "0px"
    }
};

// Valores medidos no Zendesk da VaideBet (computed styles) — aplicados inline p/ exatidão.
export const messageButtonInlineStyle: CSSProperties = {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    padding: "8px 16px",
    border: "1px solid #000",
    borderRadius: "20px",
    color: "#000"
};
